export default __webpack_public_path__ + "static/media/HansEben.6349133a.png";